import PropTypes from 'prop-types';
import { Button, IconButton, Modal } from 'rsuite';
import RemindRoundIcon from '@rsuite/icons/RemindRound';



const LatLongPedidoDialog = ({ onFechar, exibir }) => {
  return (
    <Modal onClose={onFechar} open={exibir} size="sm" style={{ zIndex: 9999 }} >
      <Modal.Header>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <IconButton
            icon={<RemindRoundIcon style={{ color: 'red', fontSize: "2em" }} />}
            style={{
              color: '#fff',
              backgroundColor: 'transparent',
            }}
          />
          <Modal.Title>Estabelecimento sem os dados de Geolocalização</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>Favor informar os dados (latitude e longitude) de Geolocalização do estabelecimento.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onFechar} appearance="subtle">
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal >
  );
};

LatLongPedidoDialog.propTypes = {
  exibir: PropTypes.bool.isRequired,
  onFechar: PropTypes.func.isRequired,
};

export default LatLongPedidoDialog;